// The guided setup's setup-step forms take the popup's full width, and their dropdown column widens with them so a
// long machine name ("Bobst SPO 1600 - Automatic cutting - 1100mm × 1600mm") is not cut off. custom_style.scss scopes
// that wider column to SETUP_STEP_CLASS -- so no page outside the guided setup is affected -- and reads its width from
// --setup-step-dropdown-width; UserUnitPriceAttributeField's select-and-Edit slot reads it too. Both fall back to the
// standard 265px. The width never goes below that 265px, and gives way to it on a narrow window (40vw).
export const SETUP_STEP_CLASS = 'frank-setup-step';
export const SETUP_STEP_DROPDOWN_WIDTH = 'clamp(265px, 40vw, 500px)';

// The props that make an element a setup-step surface: the class and the width the CSS reads, always together.
export const setupStepSurfaceProps = (style = {}) => ({
  className: SETUP_STEP_CLASS,
  style: { ...style, '--setup-step-dropdown-width': SETUP_STEP_DROPDOWN_WIDTH },
});
